export default __webpack_public_path__ + "static/media/helpscreentablet.aeebc601.png";